import { PerformanceTile } from "../../../../PerformanceTile/PerformanceTile";
import { PerformanceTileHeader } from "../../../../PerformanceTile/PerformanceTileHeader/PerformanceTileHeader";
import { IncomeTileContent, IncomeTileContentProps } from "../IncomeTileContent";
import { TileHeader } from "../../../IncomeBreakdown.types";

export interface StackedIncomeTileProps extends IncomeTileContentProps {
  stackedTiles: { header?: TileHeader }[];
}

export const StackedIncomeTile = ({ stackedTiles, ...tileProps }: StackedIncomeTileProps) => {
  const isSingle = stackedTiles.length === 1;

  return (
    <>
      <div className="income-breakdown__tile income-breakdown__tile--stacked-main">
        <IncomeTileContent {...tileProps} />
      </div>
      <div
        className={`income-breakdown__tile income-breakdown__tile--stacked-sub${
          isSingle ? " income-breakdown__tile--stacked-sub--single" : ""
        }`}
      >
        <div className="income-breakdown__sub-tiles">
          {stackedTiles.map((sub, i) => (
            <PerformanceTile key={i} link={sub.header?.link}>
              {sub.header && (
                <PerformanceTileHeader
                  {...sub.header}
                  link={undefined}
                  showArrow={sub.header.link ? true : sub.header.showArrow}
                />
              )}
            </PerformanceTile>
          ))}
        </div>
      </div>
    </>
  );
};
